import type { GatewayComponents } from '@rythmo/api-client';

export type Me = GatewayComponents['schemas']['MeDto'];
export type School = Me['schools'][number];

export type Choice = { kind: 'enter'; tenantId: string } | { kind: 'pick' } | { kind: 'none' };

/**
 * A school the console can open for this person: they are its owner or a manager there, and their
 * token carries the grant (ADR-0051), so naming it in `X-Rythmo-School` will not be refused.
 */
export function openable(school: School): boolean {
  return school.selectable && school.roles.some((role) => role === 'OWNER' || role === 'MANAGER');
}

/**
 * Where the console goes after sign-in: straight into the one school the person may open, into the
 * one they last chose on this browser while they still may, to the picker when there are several,
 * and to the no-access page when there are none.
 */
export function chooseSchool(me: Me, remembered: string | null): Choice {
  const schools = me.schools.filter(openable);
  if (remembered !== null && schools.some((school) => school.tenantId === remembered)) {
    return { kind: 'enter', tenantId: remembered };
  }
  const [only] = schools;
  if (schools.length === 1 && only !== undefined) return { kind: 'enter', tenantId: only.tenantId };
  return schools.length === 0 ? { kind: 'none' } : { kind: 'pick' };
}
